import script from "./Volunteer.vue?vue&type=script&setup=true&lang=js"
export * from "./Volunteer.vue?vue&type=script&setup=true&lang=js"

import "./Volunteer.vue?vue&type=style&index=0&id=1a6f0401&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6f0401"]])

export default __exports__